function ProductViewModeCtrl() {}

;
export default ProductViewModeCtrl;